import Swiper, {
  Navigation,
  Pagination,
  Scrollbar,
  Autoplay,
  A11y,
} from 'swiper';

class ImageTextSlider extends HTMLElement {
  connectedCallback() {
    this.swiper = this.querySelector('[data-image-text-slider]');
    this.swiperSlides = this.querySelectorAll('.swiper-slide');
    if (!this.swiper || this.swiperSlides.length < 2) return;

    this.swiperOptions = {
      modules: [A11y, Navigation, Pagination, Scrollbar, Autoplay],
      threshold: 10,
    };

    if (!this.dataset.options) return;
    const options = JSON.parse(this.dataset.options);
    if (!options) return;
    this.swiperOptions = {
      ...this.swiperOptions,
      ...options,
    };

    this.swiperInstance = new Swiper(this.swiper, this.swiperOptions);
  }
}

customElements.define('image-text-slider', ImageTextSlider);
